import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';
import { Virtuoso } from 'react-virtuoso';
import { SellApartmentFlowPaths } from 'routes';
import useApartmentSaleAds from 'api/hooks/use-apartment-sale-ads';
import useVirtualListStyle from 'hooks/use-virtial-list-style';
import Loader from 'components/loader';
import NotFound from 'components/not-found';
import { ButtonProps } from 'components/button';
import BaseScreen from 'components/base-screen';
import ErrorMessage from 'components/error-message';
import { ApartmentNavigateProps } from 'screens/apartment';
import ApartmentListItem, { APARTMENT_LIST_ITEM_HEIGHT } from 'components/apartment-list-item';
import styles from './styles.module.scss';
import useBoundStore from 'store';
import { APIUserType } from 'api/types';

const ApartmentSaleAds: React.FC = () => {
  const navigate = useNavigate();
  const listStyle = useVirtualListStyle();
  const { apartments, isLoading, error } = useApartmentSaleAds(true);
  const user = useBoundStore((s) => s.user);
  const isEmployee = user?.type !== APIUserType.CLIENT && user?.type !== APIUserType.REALTOR;

  const buttons: ButtonProps[] = isEmployee
    ? [
        {
          label: 'Добавить',
          onClick: () => navigate(SellApartmentFlowPaths.chooseApartmentComplex),
        },
      ]
    : [];

  return (
    <BaseScreen title='Список объектов на продажу. Первичка' buttons={buttons}>
      {error && apartments.length === 0 ? (
        <ErrorMessage className={styles.margined} message={error} />
      ) : isLoading ? (
        <Loader className={styles.margined} />
      ) : apartments.length > 0 ? (
        <Virtuoso
          useWindowScroll
          data={apartments}
          style={listStyle}
          className={styles.container}
          defaultItemHeight={APARTMENT_LIST_ITEM_HEIGHT}
          itemContent={(index, apartment) => {
            return (
              <ApartmentListItem
                {...apartment}
                onClick={() =>
                  navigate(SellApartmentFlowPaths.apartment, {
                    state: { id: apartment.id } as ApartmentNavigateProps,
                  })
                }
                className={clsx(index !== apartments.length - 1 && styles.border)}
                status={apartment?.availabilityStatus}
              />
            );
          }}
        />
      ) : (
        <NotFound />
      )}
    </BaseScreen>
  );
};

export default ApartmentSaleAds;
